<template>
  <div ref="transitionContainer1" class="transitionContainer1" v-show="isShow">
    <div
      class="paraparaTransContainer"
      ref="parapara"
      :style="{
        backgroundPosition: `${bgX}px ${bgY}px`,
        backgroundSize: `${bgSizeX}px ${bgSizeY}px`
      }"
    ></div>
    <!--<div ref="transitionC" class="transitionContainer">
      <div ref="transition" class="transition__inner"></div>
      <div ref="transition2" class="transition__inner2"></div>
    </div>-->
  </div>
</template>

<script>
import { TweenMax, Expo } from "gsap";
import * as types from "../store/modules/mode/types";
import * as StoreUtil from "../util/StoreUtil";
const cols = 7;
const rows = 3;
const max = 20;
const defTime = 30;
const defTime2 = 50;
const longTime = 90;
// const longTime2 = 100;
const time = [
  defTime,
  defTime,
  defTime,
  defTime,
  defTime,
  defTime,
  defTime,
  longTime,

  defTime2,
  defTime2,
  defTime2,
  longTime - 20,

  defTime,
  defTime2,
  defTime,
  longTime- 20,

  defTime,
  defTime2,
  defTime2
];

export default {
  name: "Transition",
  computed: {
    mode() {
      return this.$store.state.mode.mode;
    },
    modeTrans() {
      return this.$store.state.mode.modeTransition;
    }
  },
  data() {
    return {
      isShow: false,
      next: null,
      bgX: 0,
      bgY: 0,
      bgIndex: 0,
      bgSizeX: 2674,
      bgSizeY: 1408,
      width: 0
    };
  },
  watch: {
    modeTrans(val) {
      console.log("transition mode val", val);
      if (val == types.MODE_AREA) {
        this.next = val;
        this.parapara();
        // this.tween(val);
      } else if (val == types.MODE_TUTORIAL) {
        this.next = val;
        this.parapara();
        // this.tween(val);
      }
    },
    mode(val) {
      console.log("transition original val", val);
    }
  },

  mounted() {
    this.initSize();
    window.addEventListener("resize", ev => this.initSize());
  },
  methods: {
    initSize() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      this.bgSizeX = (this.width + 10) * cols;
      this.bgSizeY = (this.height + 4 + 6) * rows;
    },
    parapara() {
      this.initSize();
      this.isShow = true;
      this.bgIndex = 0;
      this.bgX = this.bgY = 0;
      this.$refs.transitionContainer1.style = "";
      this.tweenBg();
    },
    tweenBg() {
      this.updateBg();
      this.bgIndex++;
      const delay = time[this.bgIndex - 1] || defTime;
      // console.log("this.bgIndex", this.bgIndex, delay, this.bgX, this.bgY);
      if (this.bgIndex > max) {
        this.completeParapara();
      } else {
        setTimeout(() => {
          this.tweenBg();
        }, delay);
      }
    },
    updateBg() {
      //x: 191px, y: 352px
      // this.bgX = -191 * 2 * (this.bgIndex % cols) - 4;
      // 0: -4 1:-422px
      // width : 414
      // 7: 2542px
      //2960px 2220px//x: 191px, y: 352px
      this.bgX = -(this.width + 10) * (this.bgIndex % cols) - 4;
      this.bgY = Math.floor(this.bgIndex / cols) * -(this.height + 4 + 6) - 6;
    },
    completeParapara() {
      const el = this.$refs.transitionContainer1;
      TweenMax.fromTo(
        el,
        0.6,
        { opacity: 1 },
        {
          opacity: 0,
          delay: 0.3,
          onStart: () => {
            console.log("goto", this.next);
            StoreUtil.goto(this.next);
          },
          onComplete: ()=> {
            this.isShow = false;
          }
        }
      );
    },
    initTween() {
      const el = this.$refs.transitionC;
      TweenMax.to(el, 0, { x: -1550 });
    },
    tween(val) {
      this.isShow = true;
      const w = 510;
      const el = this.$refs.transitionC;
      const el_in1 = this.$refs.transition;
      const el_in2 = this.$refs.transition;
      console.log("[Transition] tween", val, el);
      const duration = 0.7;
      const ease = Expo.easeInOut;
      TweenMax.fromTo(
        el,
        duration,
        { x: -1550 },
        { visibility: "visible", x: 422, ease: ease }
      );
      TweenMax.fromTo(
        el_in1,
        duration,
        { rotation: -13 },
        { rotation: -3, ease: ease }
      );
      TweenMax.fromTo(
        el_in2,
        duration,
        { left: 30 },
        {
          left: 49,
          ease: ease,
          onComplete: () => {
            this.hide();
          }
        }
      );

      setTimeout(() => {
        StoreUtil.goto(val);
        console.log("[Transition] settimeout", val);
      }, duration * 0.5 * 1000);
    },
    hide() {
      this.isShow = false;
    }
  }
};
</script>

<style scoped lang="sass">
@import "../sass/zindex"
@import "../sass/common"
.paraparaTransContainer
  position: fixed
  @include fit
  background: url("/img/transition2.png") 0 0 no-repeat
  background-size: 1337px*2 1062px*2
  /*background-size: contain*/
  //background-size: 1338px*2 1062px*2
  transform: scale(1.02)




.transitionContainer1
  position: fixed
  z-index: $z_modal
  //pointer-events: none
  @include fit
  overflow: hidden
.transitionContainer
  visibility: hidden
  position: absolute




.transition__inner
    position: absolute
    z-index: 2
    top: -100px
    width: 1500px
    height: 1000px
    transform: rotate(-10deg)
    background-color: #000
    //background: url("/img/transbg1.png") center top repeat-y
.transition__inner2
    position: absolute
    z-index: 1
    top: -100px
    left: 50px
    width: 1500px
    height: 1000px
    transform: rotate(-10deg)
    background-color: #464646
    //background: url("/img/transbg1.png") center top repeat-y
</style>
